import React from 'react'
import classes from './common.module.scss'

import { Text } from './Text'

const Form = (props: any) => <form className={classes.form} {...props} />
export const FormTitle = (props: any) => <Text className={classes.FormTitle} {...props} />

export default Form
